var map = {
	"./0.png": "8d84",
	"./1.png": "c1c5",
	"./2.png": "81e5",
	"./Lightning.svg": "972b",
	"./Map_Pin.png": "73af",
	"./Time_atack.svg": "7af0",
	"./app-store.png": "89a7",
	"./app-store.svg": "36ea",
	"./call-ic.svg": "ee6f",
	"./card1.svg": "1607",
	"./card2.svg": "4451",
	"./cart.svg": "dd35",
	"./confirmed-icn.svg": "021c",
	"./default-img.jpg": "98f5",
	"./deonde-icon.svg": "710d",
	"./deonde-poweredby.svg": "53a3",
	"./discount.png": "8864",
	"./eggs.png": "192d",
	"./empty_cart.png": "d96b",
	"./error.png": "fa93",
	"./facbook-ic.svg": "c2f2",
	"./facebook-ic.svg": "3eb1",
	"./food-dish.jpg": "052d",
	"./google-play.png": "c4cb",
	"./gps-ic.svg": "0dbc",
	"./gps.png": "30dc",
	"./gps.svg": "42f0",
	"./gps1.png": "2b68",
	"./icon_delivery_marker.png": "290c",
	"./icon_store_marker.png": "5a3a",
	"./image-shape.png": "9d48",
	"./info.svg": "db39",
	"./insta-ic.svg": "c458",
	"./linkedin-ic.svg": "ab31",
	"./loader.gif": "95cd",
	"./loading.gif": "12ae",
	"./login.svg": "d625",
	"./logo-placeholder-image.png": "cd9b",
	"./logo-white.svg": "a266",
	"./logo.svg": "e347",
	"./map.png": "8708",
	"./map1.png": "947a",
	"./no-time-slot.svg": "58d8",
	"./no_address_found.png": "aa37",
	"./no_promocode.png": "55b6",
	"./no_promocode.svg": "6e03",
	"./no_search.png": "082f",
	"./no_store.png": "a3b2",
	"./non_veg.png": "5096",
	"./nonveg-icon.svg": "c8b5",
	"./offer-ic.svg": "00f5",
	"./place_holder.png": "bd0e",
	"./play-store.svg": "970f",
	"./promocode.png": "d6cd",
	"./promocode.svg": "95c6",
	"./share-icon.png": "337f",
	"./share-icon.svg": "e7f2",
	"./shop-icon.png": "9018",
	"./sub-calendar.svg": "859e",
	"./sub-icon-white.svg": "6254",
	"./subscription-icon.svg": "6494",
	"./support-icon.svg": "6b9a",
	"./support.png": "a884",
	"./sync.png": "c4d6",
	"./twitter-ic.svg": "7d1e",
	"./user-profile.svg": "0550",
	"./veg-icon.svg": "d455",
	"./whatsapp-ic.svg": "1e84",
	"./whatsapp-icon.png": "5608",
	"./whatsapp-image.svg": "db28",
	"./whatsapp-images.png": "9fe0",
	"./youtube-ic.svg": "3471"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7584";